import { server_connection } from 'config';
import history from 'history.js';

export const GET_EVENT_STUDENT_LIST  = '[GRADEBOOK APP] GET EVENT STUDENT LIST';
export const GET_COURSE_EVENT_LIST   = '[GRADEBOOK APP] GET COURSE EVENT LIST';
export const GET_COURSE_STUDENT_LIST = '[GRADEBOOK APP] GET COURSE STUDENT LIST';
export const GET_COURSE_NAME         = '[GRADEBOOK APP] GET COURSE NAME';
export const GET_COURSE_LIST         = '[GRADEBOOK APP] GET COURSE LIST';
export const GET_STUDENT_EVENT_LIST  = '[GRADEBOOK APP] GET STUDENT EVENT LIST';
export const UPDATE_GRADEBOOK_SCORE  = '[GRADEBOOK APP] UPDATE GRADEBOOK SCORE';
export const GET_EVENT_INFO          = '[GRADEBOOK APP] GET EVENT INFO';
export const GET_STUDENT_NAME        = '[GRADEBOOK APP] GET STUDENT NAME';
export const GET_COURSE_GRADEBOOK    = '[GRADEBOOK APP] GET COURSE GRADEBOOK';
export const GET_STUDENT_GRADEBOOK   = '[GRADEBOOK APP] GET STUDENT GRADEBOOK';


export function getEventStudentList(event_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/get_event_student_list/' + event_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_EVENT_STUDENT_LIST,
                    payload: responseData,
                });
            });
    }
}

export function generateBlankStudentSubmission(event_id, student_id, quiz_id, assignment_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/generate_blank_student_submission',
        {
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({ event_id, student_id, quiz_id, assignment_id })
        })
        .then((response) => response.json())
        .then((responseData) => {
            if(quiz_id) {
                history.push(`/quiz/grader/${responseData.student_quiz_id}`);
            } else if(assignment_id) {
                history.push(`/assignment/grader/${responseData.student_assignment_id}`);
            }
        });        
    }
}

export function getCourseEventList(calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/get_course_event_list/' + calendar_course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_EVENT_LIST,
                    payload: responseData.eventList,
                });
                dispatch({
                    type: GET_COURSE_NAME,
                    payload: responseData.course_name,
                })
            });
    }
}

export function getStudentGradebook(calendar_course_id, student_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/get_student_gradebook',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ calendar_course_id, student_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_STUDENT_GRADEBOOK,
                    payload: responseData,
                });
            });
    }
}

export function getCourseStudentList(calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/get_course_student_list/' + calendar_course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_STUDENT_LIST,
                    payload: responseData
                });
            })
    }
}

export function getCourseList(auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/get_course_list/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_LIST,
                    payload: responseData
                });
            })
    }
}

export function updateGradebookScore(gradebook_detail_id, new_score) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_GRADEBOOK_SCORE,
            payload: { gradebook_detail_id, new_score },
        });
    }
}

export function saveGradebookScore(gradebook_detail_id, Score) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/update_event_grade',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ gradebook_detail_id, Score })
            })
    }
}

export function getEventInfo(company_calendar_event_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/get_event_info/' + company_calendar_event_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_EVENT_INFO,
                    payload: responseData
                });
            })
    }
}

export function getCourseGradebook(calendar_course_id) {
    return (dispatch) => {
        fetch(server_connection + '/gradebook/course_gradebook/' + calendar_course_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_COURSE_GRADEBOOK,
                    payload: responseData
                })
            })
    }
}


// WEBPACK FOOTER //
// src/main/content/gradebook/store/actions/gradebook.actions.js